module.exports = __webpack_public_path__ + "img/5.2.5c65b857.png";